import axios from 'axios' // 引入axios
import qs from 'qs' // 引入qs

// const baseURL = 'https://banghao.59156.cn';
const baseURL = 'https://www.beiyetuku.com';
axios.defaults.baseURL = baseURL; //请求地址的域名（此处使用了代理所以直接填／apis

// 拦截响应response，进行错误处理
axios.interceptors.response.use(function (response) {
  // 成功处理
  return response;
}, function (error) {
  // 失败处理
  error.code = error.response.status
  switch (error.response.status) {
    case 400:
      error.message = '错误请求'
      break;
    case 401:
      error.message = '未授权，请重新登录'
      break;
    case 403:
      error.message = '拒绝访问'
      break;
    case 404:
      error.message = '请求错误,未找到该资源'
      break;
    case 405:
      error.message = '请求方法未允许'
      break;
    case 408:
      error.message = '请求超时'
      break;
    case 500:
      error.message = '服务器端出错'
      break;
    case 501:
      error.message = '网络未实现'
      break;
    case 502:
      error.message = '网络错误'
      break;
    case 503:
      error.message = '服务不可用'
      break;
    case 504:
      error.message = '网络超时'
      break;
    case 505:
      error.message = 'http版本不支持该请求'
      break;
    default:
      error.message = `连接错误${error.response.status}`
  }
  return Promise.reject(error);
});

async function request(Uri, params, tips) {
// 这里主要是post方法的封装，get方法同理

  var options = {
    url: Uri,
    data: params,
  };
  options.method = 'post'
  if (options.config === 'formData') {
    options.headers = {'Content-Type': 'multipart/form-data'}
  } else {
    options.data = JSON.stringify(options.data)
  }
  return new Promise((resolve, reject) => {
    axios(options).then(res => {
      //  这里主要根据后来返回的数据作判断，请根据实际情况
      if (res.status === 200) {
        if(res.data.code == 205){

          //清除缓存的数据
          localStorage.setItem('by_token', '');
          localStorage.setItem('by_uid', '');
          localStorage.setItem('by_openid', '');
          localStorage.setItem('by_unionid', '');
          window.location.href = '/';
        }else {
          console.log(Uri);
          console.log(JSON.stringify(params));
          console.log(`${tips || ''}`);
          console.log(res.data);
          resolve(res.data)
        }
      } else {
        console.log(`status: ${res.data.status}, message: ${ res.data.message }`);
        // this.$message.error(`status: ${res.data.status}, message: ${ res.data.message }`)
        reject(res.data)
      }
    }).catch(error => {
      // 显示拦截器对respone处理后的可读错误
      console.log(`${error.code} : ${ error.message }`)
      // this.$message.error(`${error.code} : ${ error.message }`)
    })
  })
}

export default { request, baseURL}

//安装axios
//npm i axios

//安装qs
// npm i qs

//main.js
// import Request from '@/utils/request' // 引入封装的文件
// const { request } = Request
// Vue.prototype.$http = request // 挂载到全局上

//使用方法
/*

mounted () {
  that.$http('/app/index/index', {}).then(res =>{
    console.log(res);

  });
}

*/




// WEBPACK FOOTER //
// ./src/utils/request.js